import { ScreeningActionEntity } from '../entities/app-base-screening';
import { WithUuid } from '../extensions/app-extensions';

export function isScreeningActionEntity(item: unknown): item is WithUuid<ScreeningActionEntity> {
  return (
    !!item &&
    typeof item === 'object' &&
    item.hasOwnProperty('screening_config_uuid') &&
    item.hasOwnProperty('monitoring_origin_entity_uuid') &&
    item.hasOwnProperty('screening_entity_uuid') &&
    item.hasOwnProperty('approved_flag') &&
    item.hasOwnProperty('removed_flag')
  );
}
